import React, { memo } from 'react'
import { Collapse } from 'react-bootstrap'
import { ProductsDropdownList } from './components/ProductDropdownList'

interface IProductsDropdown {
    open: boolean
}

export const ProductsDropdown = memo(function ProductsDropdown({
    open,
}: IProductsDropdown) {
    return (
        <Collapse in={open}>
            <div className="p-relative w-100">
                <ProductsDropdownList />
            </div>
        </Collapse>
    )
})
